// extracted by mini-css-extract-plugin
export default {"wrapper":"MainLayout_wrapper__rUlkL","inner":"MainLayout_inner__qYm6n"};